import { TranslateHelper } from './../../../../../_helpers/translate-helper';
import { Component, Input, OnInit } from '@angular/core';
import { CurrencyFormatPipe } from '../../../../../shared/pipes/currency-format.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { OptionsDetailsViewerComponent } from '../../../../../shared/components/options-details/options-details.component';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { BookingLineSummaryComponent } from '@app/shared/components/booking-line-summary/booking-line-summary.component';

@Component({
    selector: 'app-professional-booking-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, NgIf, OptionsDetailsViewerComponent, DatePipe, TranslateModule, CurrencyFormatPipe, BookingLineSummaryComponent]
})
export class ProfessionalOrderDetailsComponent implements OnInit {

  constructor(public translateHelper: TranslateHelper) { }

  @Input() order

  ngOnInit(): void {
  }

}
